import { SOFTWARE } from '../constant/actionTypes';

const getSoftwareSubmoduleVersionsList = (state, action) => {
  switch (action.type) {
    case SOFTWARE.SUBMODULE_VERSION.INITIATE:
      return { isFetching: true, data: action.payload };
    case SOFTWARE.SUBMODULE_VERSION.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SOFTWARE.SUBMODULE_VERSION.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getSoftwareSubmoduleVersionsList;
